module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('ed-tab-nav', {
    staticClass: "uniform",
    attrs: {
      "workflow": ""
    }
  }, [_c('ed-tab', {
    attrs: {
      "title": "Completed Agenda",
      "completed": true,
      "icon": ['fal', 'list-alt']
    }
  }, [_c('project-agenda')], 1), _c('ed-tab', {
    attrs: {
      "title": "Project Information",
      "active": true,
      "icon": ['fal', 'clipboard']
    }
  }, [_c('project-information')], 1), _c('ed-tab', {
    attrs: {
      "title": "Clients",
      "completed": true,
      "icon": ['fal', 'address-book']
    }
  }, [_c('project-clients')], 1), _c('ed-tab', {
    attrs: {
      "title": "Services",
      "icon": ['fal', 'shopping-basket']
    }
  }, [_c('p', [_c('ed-button', {
    staticClass: "btn btn-actionbar",
    on: {
      "click": _vm.create
    }
  }, [_vm._v("Create!")])], 1)]), _c('ed-tab', {
    attrs: {
      "title": "Design & Layout",
      "icon": ['fal', 'paint-brush']
    }
  }, [_c('project-design')], 1), _c('ed-tab', {
    attrs: {
      "title": "Project Settings",
      "icon": ['fal', 'rocket']
    }
  }, [_c('project-settings')], 1)], 1), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('ed-button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.showModal1 = true
      }
    }
  }, [_vm._v("Launch Modal 1")]), _c('ed-modal', {
    attrs: {
      "show": _vm.showModal1,
      "title": "Budget Information",
      "subtitle": "Tell us about your budget."
    },
    on: {
      "close": function($event) {
        _vm.showModal1 = false
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('program-list', {
    attrs: {
      "legacy": "true",
      "layout": "small"
    }
  })], 1)])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32c48a74","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/_modules/Programs/create.vue
// module id = hFyc
// module chunks = 13 14